import Alpine from 'alpinejs';

export class GoogleAuth {
    private googleAuthUrl = '/auth/google/get_auth_url';

    async login(source: string) {
        window.analytics_track_event('signup', 'google_initiated', source);
        const returnTo = encodeURIComponent(window.location.pathname);
        const urlResponse = await fetch(`${this.googleAuthUrl}?return_to=${returnTo}`);
        const urlData = await urlResponse.json();

        window.location.href = `${urlData.url}&next=${window.location.pathname}`;
    }
}

Alpine.data('googleAuth', () => new GoogleAuth());
